const ItemThree = () => {
    return(
        <>

<div className="hero-slide-item swiper-slide">
                
<div className="hero-slide-bg">
    <img src="assets/images/slider/slide-3.png" alt="Slider" />
</div>

</div>    

        </>
    )
}

export default ItemThree;